import dayjs from 'dayjs'

export const formatDate = (date: string, format = 'D MMMM YYYY'): string => {
    return dayjs(date).format(format)
}